// extracted by mini-css-extract-plugin
export var noOverflowHidden = "_al-0";
export var optionCard = "_al-1";